import TreeMenuIcon from "../components/NavigationTree2/TreeMenuIcon";
import BaseModel from "../models/BaseModel";
import BaseModelMap from "../models/BaseModelMap";
import BaseModelReference from "../models/BaseModelReference";
import ObjectSet from "../models/ObjectSet";
import TreeViewModel from "../models/TreeviewModel";
import { sortArrayByProperty } from "../models/utils";

export default class ObjectSetTreeviewModel extends TreeViewModel {
  constructor(obj: BaseModel) {
    super(obj);
  }

  get typedObj(): ObjectSet {
    return this.obj as ObjectSet;
  }

  get isSelectable(): boolean {
    return false;
  }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return true;
  }

  getDisableEdit(): boolean {
    return true;
  }

  get childCollection(): Array<BaseModel> | undefined {
    const res = new Array<BaseModel>();

    sortArrayByProperty(this.typedObj.getAll(), "tag").forEach((a) => {
      const ref = new BaseModelReference({ referencedObject: a }, this.typedObj);
      ref.additionalInlineButtons = [
        <TreeMenuIcon
          onClick={() => {
            if (state.activePanes.isOpen(a.id)) {
              state.activePanes.activatePane(a.id);
            } else {
              state.activePanes.openPane(a);
            }
            return true;
          }}
          iconName={"edit"} //  "file", // "edit",  // no itx
          tooltipKey={"homePane.openConsumerSettings"}
          objName={a.className + a.fullTag}
          key={a.className + a.fullTag + "open"}
        />,
      ];

      ref.usefromRefencedTreeviewObject.fullTitle = true;
      ref.usefromRefencedTreeviewObject.titlePostfix = true;
      res.push(ref);
    });
    return res;
  }

  getButtons(): JSX.Element[] | undefined {
    return [super.inlineButton_Delete()];
  }
}
